import React, { useState, useEffect } from 'react';
import apiClient from '../services/webTicketApiClient';
import { Link, useParams } from 'react-router-dom';
import './Ticket.css'; // Import the stylesheet

// Helper function to format the date and time
const formatDateTime = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  const options = {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: true
  };
  return date.toLocaleString('en-US', options);
};

// Helper to check for valid string content from the API
const isValidString = (str) => {
  return str && str !== 'string';
};

function JobManagement() {
  const [jobs, setJobs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { jobRunId } = useParams();

  useEffect(() => {
    const controller = new AbortController();

    const fetchJobs = async () => {
      try {
        setIsLoading(true);
        setError(null);
        // Use the pre-configured apiClient. The base URL is handled automatically.
        const response = await apiClient.get("/api/v2/web/tickets", {
          signal: controller.signal,
        });
        setJobs(response.data);
      } catch (err) {
        if (apiClient.isCancel(err)) { // Use isCancel from the apiClient instance
          console.log('Request canceled', err.message);
        } else {
          setError('Failed to fetch the list of tickets for this user.');
          console.error(err);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchJobs();

    return () => {
      controller.abort();
    };
  }, []);

  return (
    <div className="section ticket-list">
      <h2>All Tickets</h2>
      {isLoading && <div>Loading tickets...</div>}
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {!isLoading && !error && jobs.length === 0 && <div>No tickets found for this user.</div>}
      {!isLoading && !error && jobs.length > 0 && (
        <div className="ticket-table-wrapper">
          <table className="ticket-table">
            <thead>
              <tr>
                <th scope="col">Ticket</th>
                <th scope="col">Created</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {jobs.map(job => (
                <tr key={job.jobRunId} className={job.jobRunId === jobRunId ? 'selected' : ''}>
                  <td>
                    <Link to={`/trustUserTicketStatus/${job.jobRunId}`} className="ticket-link">
                      <strong>#{job.jobRunId.substring(4, 10)}</strong>: {isValidString(job.jobTitle) ? job.jobTitle : job.jobName}
                      {isValidString(job.jobDescription) && (
                        <div className="ticket-description">
                          {job.jobDescription}
                        </div>
                      )}
                    </Link>
                  </td>
                  <td>{formatDateTime(job.startTime)}</td>
                  <td>
                    <span className={`badge status-${job.status.toLowerCase()}`}>
                      {job.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default JobManagement;
